// ContactSkeleton.tsx
import ContentLoader from "react-content-loader";

export default function ContactSkeleton() {
  return (
    <ContentLoader
      speed={1.5}
      width="100%"
      height={72}
      viewBox="0 0 400 72"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      {/* Avatar circle */}
      <circle cx="36" cy="36" r="20" />

      {/* Name */}
      <rect x="70" y="20" rx="4" ry="4" width="180" height="12" />

      {/* Last message */}
      <rect x="70" y="40" rx="3" ry="3" width="140" height="10" />
    </ContentLoader>
  );
}